// extracted by mini-css-extract-plugin
export default {"HeroBanner":"HeroBanner-module__HeroBanner--HMaN"};